// Fonctions utilitaires
function getUrlParam(param) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

function filterProjects(projects, category, limit = null) {
  let filtered = projects;
  
  // Filtrer par catégorie si spécifiée
  if (category && category !== 'all') {
    filtered = projects.filter(project => project.category.includes(category));
  }
  
  // Limiter le nombre de résultats si demandé
  if (limit) {
    filtered = filtered.slice(0, limit);
  }
  
  return filtered;
}

function scrollToSection(sectionId) {
  const section = document.querySelector(sectionId);
  if (section) {
    section.scrollIntoView({ behavior: 'smooth' });
  }
}

function throttle(fn, wait = 100) {
  let timeoutId = null;
  let lastArgs = null;
  let lastCall = 0;

  return function throttled(...args) {
    const now = Date.now();
    const remaining = wait - (now - lastCall);
    lastArgs = args;

    if (remaining <= 0) {
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
      lastCall = now;
      fn.apply(this, args);
      return;
    }

    if (!timeoutId) {
      timeoutId = setTimeout(() => {
        lastCall = Date.now();
        timeoutId = null;
        fn.apply(this, lastArgs);
      }, remaining);
    }
  };
}

function rafThrottle(fn) {
  let isTicking = false;
  let lastArgs = null;

  return function rafThrottled(...args) {
    lastArgs = args;
    if (isTicking) return;

    isTicking = true;
    requestAnimationFrame(() => {
      fn.apply(this, lastArgs);
      isTicking = false;
    });
  };
}

// Vérification de sécurité pour éviter les erreurs
if (typeof window !== 'undefined') {
  window.getUrlParam = getUrlParam;
  window.filterProjects = filterProjects;
  window.scrollToSection = scrollToSection;
  window.throttle = throttle;
  window.rafThrottle = rafThrottle;
}